import { SxProps, Theme } from '@mui/material';

export const getTagsContainerSx = (isExpanded: boolean): SxProps<Theme> => ({
  position: 'relative',
  flex: 1,
  minWidth: 0,
  WebkitMaskImage: isExpanded
    ? 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)'
    : 'none',
  maskImage: isExpanded
    ? 'linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)'
    : 'none',
});

export const tagsInnerContainerSx = (isExpanded: boolean): SxProps<Theme> => ({
  display: 'flex',
  gap: 0.25,
  alignItems: 'center',
  flexWrap: 'nowrap',
  overflowX: isExpanded ? 'auto' : 'hidden',
  '&::-webkit-scrollbar': {
    height: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: '4px',
  },
});

export const chipSx: SxProps<Theme> = {
  flexShrink: 0,
};

export const expandChipSx: SxProps<Theme> = {
  flexShrink: 0,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const checkboxSx: SxProps<Theme> = {
  padding: '1px',
  marginRight: '8px',
};

export const optionLiStyle = {
  alignItems: 'center',
  display: 'flex',
  minHeight: 44,
  padding: '8px',
};

export const getAutocompleteSx = (size: 'small' | 'medium', sx?: SxProps<Theme>): SxProps<Theme> => ({
  ...sx,
  '& .MuiAutocomplete-inputRoot': {
    minHeight: size === 'small' ? 40 : 56,
    maxHeight: size === 'small' ? 40 : 56,
    flexWrap: 'nowrap',
    paddingRight: '72px !important',
    gap: 0.5,
    overflow: 'hidden',
    ...(sx as { '& .MuiAutocomplete-inputRoot'?: object })?.['& .MuiAutocomplete-inputRoot'],
  },
  '& .MuiAutocomplete-input': {
    opacity: 0,
    position: 'absolute',
    pointerEvents: 'none',
  },
  '& .MuiAutocomplete-endAdornment': {
    right: '8px',
    position: 'absolute',
  },
  '& .MuiAutocomplete-listbox': {
    paddingTop: 0,
  },
});

export const searchInputContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
  minHeight: '56px',
};

export const customPaperSearchInputSx: SxProps<Theme> = {
  width: '100%',
  height: '36px',
  padding: '8px 12px',
  fontSize: '14px',
  borderRadius: '4px',
  backgroundColor: '#f5f5f5',
  color: '#666',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
  outline: 'none',
  caretColor: '#000',
  transition: 'all 0.2s ease-in-out',
  border: 'none',
  '&:focus': {
    backgroundColor: '#ffffff',
    boxShadow: 'inset 0 0 0 1px #1976d2',
  },
  '&:placeholder-shown': {
    color: '#999',
  },
};

export const searchInputSx: SxProps<Theme> = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    height: '36px',
    fontSize: '14px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '& fieldset': {
      border: 'none',
    },
    '&:hover': {
      backgroundColor: '#efefef',
      cursor: 'text',
    },
    '&.Mui-focused': {
      backgroundColor: '#ffffff',
      boxShadow: 'inset 0 0 0 1px #1976d2',
      '& fieldset': {
        border: '1px solid #1976d2',
      },
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '8px 12px',
    color: '#666',
    cursor: 'text',
    caretColor: '#000',
    '&::placeholder': {
      color: '#999',
      opacity: 1,
    },
    '&::selection': {
      backgroundColor: '#1976d2',
      color: '#ffffff',
    },
  },
};
